import { PygCard } from '@pyg-shared/pyg-x-card/pyg-x-card.component';

export const VQcards: PygCard[] = [
  {
    id: 1,
    title: 'Frictionless Queue Management',
    image: 'frictionless_queue_management.png',
    list: [
      [
        {
          text: 'vq.card1.first.part1',
          type: 'normal',
        },
        {
          text: 'vq.card1.first.part2',
          type: 'bold',
        },
      ],
      [
        {
          text: 'vq.card1.second.part1',
          type: 'normal',
        },
        {
          text: 'vq.card1.second.part2',
          type: 'bold',
        },
        {
          text: 'vq.card1.second.part3',
          type: 'normal',
        },
      ],
      [
        {
          text: 'vq.card1.third.part1',
          type: 'normal',
        },
        {
          text: 'vq.card1.third.part2',
          type: 'bold',
        },
      ],
    ],
    points: [
      {
        svg: 'clock-item.svg',
        text: 'vq.card.reduced_time',
      },
      {
        svg: 'smartphone-item.svg',
        text: 'vq.card.intuitive_interface',
      },
      {
        svg: 'bell-item.svg',
        text: 'vq.card.smart_noti',
      },
    ],
  },
  {
    id: 2,
    title: 'Online booking',
    image: 'online_booking.png',
    list: [
      [
        {
          text: 'vq.card2.first.part1',
          type: 'normal',
        },
        {
          text: 'vq.card2.first.part2',
          type: 'bold',
        },
        {
          text: 'vq.card2.first.part3',
          type: 'normal',
        },
        {
          text: 'vq.card2.first.part4',
          type: 'bold',
        },
      ],
      [
        {
          text: 'vq.card2.second.part1',
          type: 'normal',
        },
        {
          text: 'vq.card2.second.part2',
          type: 'bold',
        },
      ],
      [
        {
          text: 'vq.card2.third.part1',
          type: 'normal',
        },
        {
          text: 'vq.card2.third.part2',
          type: 'bold',
        },
        {
          text: 'vq.card2.third.part3',
          type: 'normal',
        },
      ],
    ],
    points: [
      {
        svg: 'users-item.svg',
        text: 'vq.card.online_queue',
      },
      {
        svg: 'plus-square-item.svg',
        text: 'vq.card.covid_safe',
      },
      {
        svg: 'bell-item.svg',
        text: 'vq.card.smart_noti',
      },
    ],
  },
  {
    id: 3,
    title: 'Effective shift planning',
    image: 'effective_shift_planning.png',
    list: [
      [
        {
          text: 'vq.card3.first.part1',
          type: 'bold',
        },
        {
          text: 'vq.card3.first.part2',
          type: 'normal',
        },
      ],
      [
        {
          text: 'vq.card3.second.part1',
          type: 'bold',
        },
        {
          text: 'vq.card3.second.part2',
          type: 'normal',
        },
      ],
      [
        {
          text: 'vq.card3.third.part1',
          type: 'normal',
        },
        {
          text: 'vq.card3.third.part2',
          type: 'bold',
        },
      ],
      [
        {
          text: 'vq.card3.fourth.part1',
          type: 'bold',
        },
        {
          text: 'vq.card3.fourth.part2',
          type: 'normal',
        },
      ],
      [
        {
          text: 'vq.card3.fifth.part1',
          type: 'bold',
        },
        {
          text: 'vq.card3.fifth.part2',
          type: 'normal',
        },
      ],
      [
        {
          text: 'vq.card3.sixth.part1',
          type: 'normal',
        },
        {
          text: 'vq.card3.sixth.part2',
          type: 'bold',
        },
        {
          text: 'vq.card3.sixth.part3',
          type: 'normal',
        },
      ],
    ],
    points: [
      {
        svg: 'user-check-item.svg',
        text: 'vq.card.staff_allocation',
      },
      {
        svg: 'increase-bar-chart-item.svg',
        text: 'vq.card.conversions',
      },
      {
        svg: 'activity-item.svg',
        text: 'vq.card.productivity',
      },
    ],
  },
  {
    id: 4,
    title: 'Complex overview of the customer journey',
    image: 'complex_overview.png',
    list: [
      [
        {
          text: 'vq.card4.first.part1',
          type: 'normal',
        },
        {
          text: 'vq.card4.first.part2',
          type: 'bold',
        },
      ],
      [
        {
          text: 'vq.card4.second.part1',
          type: 'normal',
        },
        {
          text: 'vq.card4.second.part2',
          type: 'bold',
        },
        {
          text: 'vq.card4.second.part3',
          type: 'normal',
        },
      ],
      [
        {
          text: 'vq.card4.third.part1',
          type: 'normal',
        },
        {
          text: 'vq.card4.third.part2',
          type: 'bold',
        },
      ],
      [
        {
          text: 'vq.card4.fourth.part1',
          type: 'bold',
        },
        {
          text: 'vq.card4.fourth.part2',
          type: 'normal',
        },
      ],
      [
        {
          text: 'vq.card4.fifth.part1',
          type: 'normal',
        },
        {
          text: 'vq.card4.fifth.part2',
          type: 'bold',
        },
      ],
      [
        {
          text: 'vq.card4.sixth.part1',
          type: 'normal',
        },
        {
          text: 'vq.card4.sixth.part2',
          type: 'bold',
        },
        {
          text: 'vq.card4.sixth.part3',
          type: 'normal',
        },
      ],
    ],
    points: [
      {
        svg: 'bar-chart-item.svg',
        text: 'vq.card.prediction',
      },
      {
        svg: 'thumbs-up-item.svg',
        text: 'vq.card.decision',
      },
      {
        svg: 'smile-item.svg',
        text: 'vq.card.loyalty',
      },
    ],
  },
];
